// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__cUhAQ","col":"styles_col__3Cv3X","fulfillmentStatus":"styles_fulfillmentStatus__aJZab","emailCol":"styles_emailCol__3GufF"};